module.exports = __webpack_public_path__ + "img/21.8fca5573.jpg";